// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

export function FinishMessage(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch(country){
    case 'br':
      return (
        <Paragraph>
          Falta pouco! Para finalizar sua compra no
          site <MerchantName>{incomingPayment.merchant.name}</MerchantName> escolha
          abaixo a sua forma preferida de pagamento:
        </Paragraph>
      );

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'py':
    case 'uy':
      return (
        <Paragraph>
          ¡Falta poco! Completa tus datos abajo para finalizar tu compra en el
          sitio <MerchantName>{incomingPayment.merchant.name}</MerchantName>
        </Paragraph>
      );

    case 'za':
    case 'ke':
    case 'ng':
      return (
        <Paragraph>
            Almost there! To complete your purchase
            at <MerchantName>{incomingPayment.merchant.name}</MerchantName> choose
            your preferred payment method below:
        </Paragraph>
      );

    default:
      throw new Error(`No message found for finish-your-payment message in country ${country}`);
  }

}

const Paragraph = styled.p`
  color: rgba(51, 51, 51, 0.8);
`;

const MerchantName = styled.span`
  font-weight: 600;
`;
